import { cn } from '@src/design-system/helpers';
import { useSetViewAsDefault } from '../services/set-view-as-default';
import { Loader2, Pin } from 'lucide-react';
import type { ComponentProps } from 'react';
import viewApi from '../services/view-api';

export const MarkViewAsDefaultBtn = ({
  staticFilterId,
  isDefault,
  className,
  ...props
}: {
  staticFilterId: number | string;
  isDefault: boolean;
} & ComponentProps<'button'>) => {
  const { mutate: setViewAsDefault, isPending } = useSetViewAsDefault();
  const { mutate: updateView, isPending: isUpdating } = viewApi.useUpdate();

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (isPending) return;

        if (isDefault) {
          updateView({
            id: staticFilterId,
            is_default: false,
          });
          return;
        }
        setViewAsDefault(staticFilterId);
      }}
      className={cn(
        'cursor-pointer shrink-0 flex justify-center items-center size-6 bg-secondary-50 rounded-lg text-secondary-1000 hover:bg-secondary-100',
        className
      )}
      {...props}
    >
      {isPending || isUpdating ? (
        <Loader2
          className='animate-spin'
          size={16}
        />
      ) : (
        <Pin
          size={16}
          className='rotate-45'
          {...(isDefault && { fill: 'currentColor' })}
        />
      )}
    </button>
  );
};
